<template>
  <div class="loading-container">
    <div class="loading-dots">
      <span class="dot dot-1"></span>
      <span class="dot dot-2"></span>
      <span class="dot dot-3"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style lang="scss" scoped>
.loading-container {
  display: flex;
  align-items: center;
  padding: 20px;
}

.loading-dots {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: loading-pulse 1.4s infinite ease-in-out;
}

.dot-1 {
  background-color: #303133;
  animation-delay: 0s;
}

.dot-2 {
  background-color: #909399;
  animation-delay: 0.2s;
}

.dot-3 {
  background-color: #d9d9d9;
  animation-delay: 0.4s;
}

@keyframes loading-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.95);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>